module.exports = __webpack_public_path__ + "media/images/emblems/Maienfeld_wappen-72c2fadd2c0f5938f7e61c2f5a75743c.svg";